import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Nav, Navbar, Button, Badge } from "react-bootstrap";
import { Send, User, HelpCircle, BookOpen, Home } from "lucide-react";
import { Link, useLocation } from "react-router-dom"; // Assumes you use react-router-dom

const Header = ({ user }) => {
  const location = useLocation();

  // Helper to check if a link is active for styling
  const isActive = (path) => location.pathname === path;

  return (
    <Navbar 
      expand="lg" 
      sticky="top" 
      className="bg-white shadow-sm py-3 mb-4 border-bottom"
      style={{ zIndex: 1050 }}
    >
      <Container>
        {/* Logo Section */}
        <Navbar.Brand 
          as={Link} 
          to="/home-page" 
          className="d-flex align-items-center fw-bold text-primary fs-4"
          style={{ letterSpacing: "-0.5px" }}
        >
          <div className="bg-primary text-white p-1 rounded-3 me-2 d-flex align-items-center justify-content-center">
            <Send size={20} fill="currentColor" />
          </div>
          beacon<span className="text-dark">SMS</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0 shadow-none" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto gap-lg-3">
            <Nav.Link 
              as={Link} 
              to="/home-page" 
              className={`d-flex align-items-center fw-medium ${isActive('/home-page') ? 'text-primary' : 'text-secondary'}`}
            >
              <Home size={18} className="me-1 d-lg-none d-xl-inline" /> Home
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/home-page" 
              className={`d-flex align-items-center fw-medium ${isActive('/faq') ? 'text-primary' : 'text-secondary'}`}
            >
              <HelpCircle size={18} className="me-1 d-lg-none d-xl-inline" /> FAQ
            </Nav.Link>

            <Nav.Link 
              as={Link} 
              to="/home-page" 
              className={`d-flex align-items-center fw-medium ${isActive('/how-it-works') ? 'text-primary' : 'text-secondary'}`}
            >
              <BookOpen size={18} className="me-1 d-lg-none d-xl-inline" /> How it Works
            </Nav.Link>
          </Nav>

          
          {/* <Nav className="ms-auto align-items-center">
            {user ? (
              <div className="d-flex align-items-center bg-light px-3 py-2 rounded-pill border shadow-sm">
                <div className="me-2 text-end d-none d-sm-block">
                  <div className="fw-bold small text-dark" style={{ lineHeight: 1 }}>
                    {user.username}
                  </div>
                  <Badge bg="success" className="p-1 mt-1" style={{ fontSize: '9px' }}>
                    Active
                  </Badge>
                </div>
                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                  <User size={18} />
                </div>
              </div>
            ) : (
              <Button 
                as={Link} 
                to="/login" 
                variant="primary" 
                className="rounded-pill px-4 fw-bold shadow-sm btn-sm"
              >
                Login
              </Button>
            )}
          </Nav> */}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;